// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__f0u9X","indicator":"styles_indicator__ActS4"};